// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Cashback from "../../app/entity/Cashback.bs.js";
import * as CrmRepoManager from "../../../to-be-migrated/domain/repo/CrmRepoManager.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as Lib$PorterinFusionkitSentry from "../../../../../../node_modules/@porterin/fusionkit-sentry/src/Lib.bs.js";

function execute(onSuccess, onFailure, phone_number, customer_id, country) {
  var RepoInstance = CrmRepoManager.getCustomerRepo(undefined);
  Promise.all([
          Curry._2(RepoInstance.fetchCustomer, phone_number, country),
          Curry._2(RepoInstance.fetchCashback, customer_id, country)
        ]).then(function (param) {
        var cashback_data = param[1];
        var customer_data = param[0];
        if (customer_data.TAG !== /* Ok */0) {
          return Promise.resolve(Curry._1(onFailure, customer_data._0));
        }
        var customer_data$1 = customer_data._0;
        if (cashback_data.TAG === /* Ok */0) {
          return Promise.resolve(Curry._2(onSuccess, customer_data$1, cashback_data._0));
        }
        Curry._1(Lib$PorterinFusionkitSentry.React.captureMessage, ErrorUtils$Catalyst.resolveError(cashback_data._0));
        return Promise.resolve(Curry._2(onSuccess, customer_data$1, Cashback.$$default));
      });
  
}

var FetchCustomerInfo = {
  execute: execute
};

function execute$1(onSuccess, onFaliure, data, formData, country) {
  var RepoInstance = CrmRepoManager.getCustomerRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._3(RepoInstance.updateCustomer, data, formData, country);
              }), Curry.__1(onSuccess), Curry.__1(onFaliure));
}

var UpdateCustomer = {
  execute: execute$1
};

function execute$2(onSuccess, onFaliure, customer_id, mobile, phone_number, country) {
  var RepoInstance = CrmRepoManager.getCustomerRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._4(RepoInstance.addSecondaryNumber, customer_id, mobile, phone_number, country);
              }), Curry.__1(onSuccess), Curry.__1(onFaliure));
}

var AddSecondaryNumber = {
  execute: execute$2
};

function execute$3(onSuccess, onFaliure, customer_id, request_id, phone_number, country) {
  var RepoInstance = CrmRepoManager.getCustomerRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._4(RepoInstance.resendOTP, customer_id, request_id, phone_number, country);
              }), Curry.__1(onSuccess), Curry.__1(onFaliure));
}

var ResendOTP = {
  execute: execute$3
};

function execute$4(onSuccess, onFaliure, uuid, page_size, last_date_timestamp, country) {
  var RepoInstance = CrmRepoManager.getCustomerRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._4(RepoInstance.fetchCustomerOrder, uuid, page_size, last_date_timestamp, country);
              }), Curry.__1(onSuccess), Curry.__1(onFaliure));
}

var FetchCustomerOrder = {
  execute: execute$4
};

function execute$5(onSuccess, onFaliure, uuid, page_size, last_date_timestamp, country) {
  var RepoInstance = CrmRepoManager.getCustomerRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._4(RepoInstance.fetchTransationHistory, uuid, page_size, last_date_timestamp, country);
              }), Curry.__1(onSuccess), Curry.__1(onFaliure));
}

var FetchTransactionHistory = {
  execute: execute$5
};

function execute$6(onSuccess, onFaliure, customer_id, request_id, otp, phone_number, country) {
  var RepoInstance = CrmRepoManager.getCustomerRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._5(RepoInstance.verifyOtp, customer_id, otp, request_id, phone_number, country);
              }), Curry.__1(onSuccess), Curry.__1(onFaliure));
}

var VerifyOtpRequest = {
  execute: execute$6
};

function execute$7(onSuccess, onFaliure, customer_id, amount, country) {
  var RepoInstance = CrmRepoManager.getCustomerRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._3(RepoInstance.sendPaymentLink, customer_id, amount, country);
              }), Curry.__1(onSuccess), Curry.__1(onFaliure));
}

var SendPaymentRequest = {
  execute: execute$7
};

function execute$8(onSuccess, onFaliure, customer_id, country) {
  var RepoInstance = CrmRepoManager.getCustomerRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.verifyEmail, customer_id, country);
              }), Curry.__1(onSuccess), Curry.__1(onFaliure));
}

var VerifyEmail = {
  execute: execute$8
};

function execute$9(onSuccess, onFaliure, customer_id, wallet_balance, update_amount, updated_at, country) {
  var RepoInstance = CrmRepoManager.getCustomerRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._5(RepoInstance.updateWalletBalance, customer_id, wallet_balance, update_amount, updated_at, country);
              }), Curry.__1(onSuccess), Curry.__1(onFaliure));
}

var UpdateWalletBalance = {
  execute: execute$9
};

function execute$10(onSuccess, onFailure, customer_id, country) {
  var RepoInstance = CrmRepoManager.getCustomerRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.fetchPorterGoldDetails, customer_id, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

var FetchPorterGoldDetails = {
  execute: execute$10
};

function execute$11(onSuccess, onFailure, uuid, country) {
  var RepoInstance = CrmRepoManager.getCustomerRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.fetchCustomerConsents, uuid, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

var FetchCustomerConsents = {
  execute: execute$11
};

function execute$12(payload, country, onSuccess, onFaliure) {
  var RepoInstance = CrmRepoManager.getCustomerRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.updateCustomerConsents, payload, country);
              }), Curry.__1(onSuccess), Curry.__1(onFaliure));
}

var UpdateCustomerConsents = {
  execute: execute$12
};

function execute$13(country, onSuccess, onFaliure) {
  var RepoInstance = CrmRepoManager.getCustomerRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._1(RepoInstance.fetchBlacklistingReasons, country);
              }), Curry.__1(onSuccess), Curry.__1(onFaliure));
}

var FetchBlacklistingReasons = {
  execute: execute$13
};

function execute$14(onSuccess, onFaliure, customer_uuid, customer_mobile, gstins, country) {
  var RepoInstance = CrmRepoManager.getCustomerRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._4(RepoInstance.deleteGstins, customer_uuid, customer_mobile, gstins, country);
              }), Curry.__1(onSuccess), Curry.__1(onFaliure));
}

var DeleteGstins = {
  execute: execute$14
};

function execute$15(onSuccess, onFaliure, phone_number, country) {
  var RepoInstance = CrmRepoManager.getCustomerRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.fetchCustomer, phone_number, country);
              }), Curry.__1(onSuccess), Curry.__1(onFaliure));
}

var RefetchCustomerSummary = {
  execute: execute$15
};

export {
  FetchCustomerInfo ,
  UpdateCustomer ,
  AddSecondaryNumber ,
  ResendOTP ,
  FetchCustomerOrder ,
  FetchTransactionHistory ,
  VerifyOtpRequest ,
  SendPaymentRequest ,
  VerifyEmail ,
  UpdateWalletBalance ,
  FetchPorterGoldDetails ,
  FetchCustomerConsents ,
  UpdateCustomerConsents ,
  FetchBlacklistingReasons ,
  DeleteGstins ,
  RefetchCustomerSummary ,
  
}
/* Cashback Not a pure module */
